import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d71bf56"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "hex-shape",
  viewBox: "0 0 100 100",
  preserveAspectRatio: "none",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("polygon", { points: "50,2 98,26 98,74 50,98 2,74 2,26" })
], -1))
const _hoisted_2 = { class: "hex-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hex-logo",
  src: "/media/logos/hc.svg",
  alt: "Hacking Club"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hex-divider" }, null, -1))
const _hoisted_5 = { class: "hex-name" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hex-divider" }, null, -1))
const _hoisted_7 = { class: "hex-tag" }

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    certificate: null,
    lockedLabel: null
  },
  setup(__props: any) {

const props = __props as {
  certificate: {
    name: string;
    full_name?: string;
    has_certificate: number;
    validation_id: string;
  };
  lockedLabel: string;
}



const owned = computed(() => Number(props.certificate?.has_certificate) === 1);
const title = computed(() => props.certificate?.full_name || props.certificate?.name || "");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(owned) ? 'router-link' : 'div'), {
    to: _unref(owned) ? { name: 'certificate', query: { id: __props.certificate.validation_id } } : undefined,
    target: _unref(owned) ? '_blank' : undefined,
    class: _normalizeClass(["hex", { 'is-locked': !_unref(owned) }])
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(title)), 1),
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(owned) ? 'CERTIFICATE' : __props.lockedLabel), 1)
      ])
    ]),
    _: 1
  }, 8, ["to", "target", "class"]))
}
}

})